/*
    หน้า app2/login-with-token : แลก custom token ที่ xtable.co ส่งมา เป็น session ของ app2

    xtable.co login สำเร็จแล้วเจอว่าเป็นร้าน beta -> ขอ custom token จาก backend
    (POST /users/handoff-token) -> location.replace มาที่นี่พร้อม #token=...
    ดู modules/core/utils/authHandoff.ts

    token อยู่ใน hash ไม่ใช่ query เพราะ hash ไม่ถูกส่งไป server (hosting / CDN log)
    และต้องลบออกจาก URL ก่อนทำอย่างอื่น ไม่ให้ค้างใน address bar / history

    เขียนเป็นฟังก์ชันที่รับ dependency เข้ามา (location / history / signIn) ไม่ import
    firebase ตรง ๆ จะได้ทดสอบใน node ได้ (scripts/test-login-with-token.mjs)
*/

export const TOKEN_LOGIN_PATH = "/login-with-token";
export const TOKEN_HASH_KEY = "token";

const SIGN_IN_TIMEOUT_MS = 10 * 1000;

type TokenLoginDeps = {
  location: Pick<Location, "hash" | "pathname" | "search" | "replace">;
  history: Pick<History, "replaceState">;
  signIn: (token: string) => Promise<unknown>;
  clearCookie: () => void;
  timeoutMs?: number;
};

/** @returns true เมื่อ sign in สำเร็จ (ไป "/" ต่อ) false เมื่อต้องไป login เอง */
export async function completeTokenLogin({
  location,
  history,
  signIn,
  clearCookie,
  timeoutMs = SIGN_IN_TIMEOUT_MS,
}: TokenLoginDeps): Promise<boolean> {
  const params = new URLSearchParams(location.hash.replace(/^#/, ""));
  const token = params.get(TOKEN_HASH_KEY);
  history.replaceState(null, "", location.pathname + location.search);

  if (!token) {
    clearCookie();
    location.replace("/login");
    return false;
  }

  try {
    await withTimeout(signIn(token), timeoutMs);
    // reload เต็ม ๆ ให้ boot ใหม่ทั้งแอปพร้อม session นี้ (plugin ตอน boot จำ uid / storeId ไว้)
    location.replace("/");
    return true;
  } catch (error) {
    // token หมดอายุ / ใช้ไม่ได้ / เน็ตหลุด -> ให้ login ที่ app2 เองเหมือนเดิม
    console.warn("[tokenLogin] sign in ด้วย token จาก xtable.co ไม่สำเร็จ ให้ login เอง", error);
    clearCookie();
    location.replace("/login");
    return false;
  }
}

function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error(`sign in timeout ${ms}ms`)), ms);
    promise.then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (error) => {
        clearTimeout(timer);
        reject(error);
      }
    );
  });
}
